export default __webpack_public_path__ + "static/media/banner1.2241546e.jpg";